import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 1,
        slugId: '105132895602570622078',
        email: 'jane-doe@demo.com',
        name: 'Jane Doe',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 1245).toISOString(),
        role: 'ADMIN',
        userOrgUnits: [
            {
                id: 81,
                workspaceId: 6,
                userId: 1,
                orgUnitId: 24,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 24,
                    title: 'Workalizer',
                    slugId: 'id:03ph8a2z3n589sq',
                    path: '/Workalizer',
                    parentPath: '/',
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 2,
        slugId: '107689767922140053699',
        email: 'michael-smith@demo.com',
        name: 'Michael Smith',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 76).toISOString(),
        role: 'MANAGER',
        userOrgUnits: [
            {
                id: 79,
                workspaceId: 6,
                userId: 2,
                orgUnitId: 24,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 24,
                    title: 'Workalizer',
                    slugId: 'id:03ph8a2z3n589sq',
                    path: '/Workalizer',
                    parentPath: '/',
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 3,
        slugId: '101376091211500015070',
        email: 'john-johnson@demo.com',
        name: 'John Johnson',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 1631).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 78,
                workspaceId: 6,
                userId: 3,
                orgUnitId: 26,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 26,
                    title: 'Sales',
                    slugId: 'id:03ph8a2z3km6khy',
                    path: '/Sales',
                    parentPath: '/',
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 4,
        slugId: '116322302536022331403',
        email: 'robert-brown@demo.com',
        name: 'Robert Brown',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 5676).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 83,
                workspaceId: 6,
                userId: 4,
                orgUnitId: 27,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 27,
                    title: 'Marketing',
                    slugId: '',
                    path: null,
                    parentPath: null,
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 1).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 5,
        slugId: '111757495972683597146',
        email: 'david-smith@demo.com',
        name: 'David Smith',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: false,
        isActiveOnGoogle: false,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 202).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 80,
                workspaceId: 6,
                userId: 5,
                orgUnitId: 24,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 24,
                    title: 'Workalizer',
                    slugId: 'id:03ph8a2z3n589sq',
                    path: '/Workalizer',
                    parentPath: '/',
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 6,
        slugId: '112948364252608697575',
        email: 'john-doe@demo.com',
        name: 'John Doe',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 149).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 84,
                workspaceId: 6,
                userId: 6,
                orgUnitId: 27,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 27,
                    title: 'Marketing',
                    slugId: '',
                    path: null,
                    parentPath: null,
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 1).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 7,
        slugId: '110632195683438051624',
        email: 'daniel-smith@demo.com',
        name: 'Daniel Smith',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 317).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 82,
                workspaceId: 6,
                userId: 7,
                orgUnitId: 24,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 24,
                    title: 'Workalizer',
                    slugId: 'id:03ph8a2z3n589sq',
                    path: '/Workalizer',
                    parentPath: '/',
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 8,
        slugId: '106482657771775983354',
        email: 'emily-davis@demo.com',
        name: 'Emily Davis',
        avatar: null,
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 162).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 85,
                workspaceId: 6,
                userId: 8,
                orgUnitId: 27,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 27,
                    title: 'Marketing',
                    slugId: '',
                    path: null,
                    parentPath: null,
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 1).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 9,
        slugId: '113635518886530205668',
        email: 'liam-williams@demo.com',
        name: 'Liam Williams',
        avatar: 'data:image/jpeg;base64,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',
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 162).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 86,
                workspaceId: 6,
                userId: 9,
                orgUnitId: 27,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 27,
                    title: 'Marketing',
                    slugId: '',
                    path: null,
                    parentPath: null,
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 1).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 10,
        slugId: '100919787724072345290',
        email: 'jake-miller@demo.com',
        name: 'Jake Miller',
        avatar: 'data:image/jpeg;base64,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',
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 5676).toISOString(),
        role: 'MANAGER',
        userOrgUnits: [
            {
                id: 87,
                workspaceId: 6,
                userId: 10,
                orgUnitId: 27,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 27,
                    title: 'Marketing',
                    slugId: '',
                    path: null,
                    parentPath: null,
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 1).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    },
    {
        id: 11,
        slugId: '100279056996576522766',
        email: 'ben-davis@demo.com',
        name: 'Ben Davis',
        avatar: 'data:image/jpeg;base64,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',
        workspaceId: 6,
        createdAt: subDays(new Date(), 6).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        isDailyReport: false,
        isWeeklyReport: false,
        isMonthlyReport: false,
        isActive: true,
        isActiveOnGoogle: true,
        timezone: 'Atlantic/Azores',
        creationDate: subDays(new Date(), 1692).toISOString(),
        role: 'USER',
        userOrgUnits: [
            {
                id: 88,
                workspaceId: 6,
                userId: 11,
                orgUnitId: 27,
                isInGoogle: true,
                createdAt: subDays(new Date(), 1).toISOString(),
                updatedAt: subDays(new Date(), 1).toISOString(),
                orgUnit: {
                    id: 27,
                    title: 'Marketing',
                    slugId: '',
                    path: null,
                    parentPath: null,
                    workspaceId: 6,
                    isActive: true,
                    type: 'GOOGLE',
                    createdAt: subDays(new Date(), 1).toISOString(),
                    updatedAt: subDays(new Date(), 1).toISOString()
                }
            }
        ],
        workspace: {
            id: 6,
            customerSlugId: 'hidden',
            nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
            creationDate: subDays(new Date(), 5676).toISOString(),
            statusProcessing: 'FINISHED',
            isProcessingSync: true,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            billingContact: 'v.noha@projectli.com',
            timezone: 'Atlantic/Azores',
            useIdsAsTitles: false
        }
    }
];
